import { DrillDownPie, LoadingIcon, utils } from '@clickcease/cc-client-components-lib'
import React from 'react'
import { commaSeparatedNumber } from 'Utils/number'
import { defaultPieOptions } from './constants'
import { PieTotalStyled, PieWrapperStyled } from './Pie.styled'
import { PieProps } from './types'
import { LoaderWrapper } from 'Features/home/components/OverallDomainsPreformance/DomainsTable.styled'

export const Pie = ({ total, isLoading, options, ...otherOptions }: PieProps) => {
  const mergedOptions = utils.objectDeepMerge(defaultPieOptions, options || {})

  return (
    <PieWrapperStyled>
      {isLoading ? (
        <LoaderWrapper css={{ height: '300px', width: '100%', maxWidth: '420px' }}>
          <LoadingIcon />
        </LoaderWrapper>
      ) : (
        <>
          <DrillDownPie {...otherOptions} options={mergedOptions} />
          {total && (
            <PieTotalStyled>
              {total.title} <span>{commaSeparatedNumber(total.value)}</span>
            </PieTotalStyled>
          )}
        </>
      )}
    </PieWrapperStyled>
  )
}
